import './trips.css';
import OverallSummary from "../../components/overallSummary/overallSummary";
import DriversSummary from "../../components/driverComponent/driversSummary/driversSummary";

import {driversSummary} from "../../data/driversData";
import {useEffect, useState} from "react";
import TripsCard from "../../components/tripsComponent/tripsCards/tripsCards";
import AllTrips from "../../components/tripsComponent/allTrips/allTrips";
import CalendarType from "../../shared/calendarType/calendarType";
import DateRangePicker from "../../shared/dateRangePicker/dateRangePicker";
const Trips = () => {
    const [summary] = useState(driversSummary);
    const [newDate, setNewDate] = useState([]);

    let counter = 1;
    useEffect(() => {
    }, [])

    const handleDateChange = (date) => {
        if (date[1]) {
            setNewDate(date);
        }

    }


    return(
        <div className={'page-fade-in'}>
            <div className={'content-section'}>
                <div className=" round-corner-8 padding-tb-20 flex hr-right border-bottom margin-b-30">
                    <DateRangePicker selectRange={true} onDateChange={handleDateChange} classes={'date width-300 item-height-40'}/>
                    <CalendarType/>
                </div>

                {/*..... card dashboard .....*/}
                <div className="margin-b-50"><TripsCard/></div>

                {/*..... overall summary .....*/}
                {/*<div className="margin-b-50"><OverallSummary/></div>*/}
            </div>
            <div className=" margin-b-50">
                <div className={'content-section'}>
                    {/*..... drivers overall summary .....*/}
                    <div className=""><DriversSummary summary={summary}/></div>
                </div>
            </div>

            <div className="">
                <div className={'content-section'}>
                    {/*..... All trips .....*/}
                    <div className=""><AllTrips/></div>
                </div>
            </div>
        </div>
    )
}

export default Trips;
